import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import Spinner from 'react-spinkit';
import _ from 'lodash';

import { STUDENT, INSTRUCTOR } from "../constants/roles";
import {
    DROPBOXES__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    DROPBOXES__ROLES__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";
import Card from "../components/bootstrap/Card";
import NavBar from "../components/NavBar";
import NavLink from "../components/NavLink";
import CardBlock from "../components/bootstrap/CardBlock";
import CardHeader from "../components/bootstrap/CardHeader";

class EnrollmentPage extends AuthorizedComponent {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.state = {
            search: {
                instructor: "",
                student: ""
            }
        };

        this.handleInstructorSearchChange = this.handleInstructorSearchChange.bind(this);
        this.handleStudentSearchChange = this.handleStudentSearchChange.bind(this);
    }

    handleInstructorSearchChange(event){
        this.setState({
            search: {
                ...this.state.search,
                instructor: event.target.value
            }
        });
    }

    handleStudentSearchChange(event){
        this.setState({
            search: {
                ...this.state.search,
                student: event.target.value
            }
        });
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { dispatch, dropboxes, params, roles, roles_self, users } = this.props,
            dropboxId = parseInt(params.dropboxId)
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.id === dropboxId) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (users.dropbox !== dropboxId || _.size(roles) < 1 || _.size(users) < 1) {
                    dispatch({
                        type: DROPBOXES__ROLES__REQUESTED,
                        payload: { dropboxId }
                    });

                    dispatch({
                        type: DROPBOX__USERS__REQUESTED,
                        payload: { dropboxId },
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    renderUsersByRole(role) {
        let { users, params, roles } = this.props,
            { search } = this.state,
            filtered_users = _.filter(
                users,
                user => {
                    if (user === users.dropbox) {
                        return false;
                    }

                    const { username, first_name, last_name } = user;

                    let precept = _.find(
                            _.map(
                                _.filter(
                                    roles,
                                    dropbox_role => {
                                        return dropbox_role.role === STUDENT
                                            && dropbox_role.user.id === user.id
                                        ;
                                    }
                                ),
                                dropbox_role => {
                                    return dropbox_role.precept;
                                }
                            )
                        )
                    ;
                    precept = precept ? precept : "";

                    return _.filter(
                            [username, first_name, last_name, `${first_name} ${last_name}`, precept],
                            user_search => {
                                if (role === STUDENT) {
                                    return _.includes(
                                        (user_search).toUpperCase(),
                                        (search.student).toUpperCase()
                                    );
                                }

                                if (role === INSTRUCTOR) {
                                    return _.includes(
                                        (user_search).toUpperCase(),
                                        (search.instructor).toUpperCase()
                                    );
                                }

                                return false;
                            }
                        ).length > 0
                        ?
                            _.includes(
                                _.flatMap(
                                    _.filter(
                                        roles,
                                        dropbox_role => {
                                            return user.id === dropbox_role.user.id;
                                        }
                                    ),
                                    dropbox_role => {
                                        return dropbox_role.role;
                                    }
                                ),
                                role
                            )
                        : false
                    ;
                }
            )
        ;

        return _.map(
            _.orderBy(
                filtered_users,
                [
                    (user) => {
                        return user.username;
                    }
                ],
                ['asc']
            ),
            (user) => {
                return (
                    <Link
                        className="btn btn-sm btn-info"
                        key={`user_${user.id}`}
                        title={`${user.first_name} ${user.last_name}`}
                        to={`/dropbox/${params.dropboxId}/users/${user.id}`}
                        onlyActiveOnIndex={false}
                    >
                        {user.username}
                    </Link>
                );
            })
        ;
    }

    render() {
        const isLoading = this.props.request.sendingRequest;
        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        let { dropboxes, params } = this.props,
            dropbox = dropboxes[params.dropboxId],
            { search } = this.state
        ;

        return dropbox
        ?
            <div className="col-md-12">
                <div className={"action-links"}>
                    <NavBar
                        className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                        display
                    >
                        <NavLink
                            to={`/?expand=${dropbox.id}`}
                            className="btn btn-outline-primary btn-md"
                            side="left"
                            display
                            key="course"
                        >
                            Exit To Course <i className={"fa fa-chevron-circle-left"}/>
                        </NavLink>
                    </NavBar>
                </div>
                <h3>{dropbox.name}</h3>
                <CardBlock>
                    <Card>
                        <CardHeader className="bg-primary">Instructors</CardHeader>
                        <CardBlock>
                            <input
                                name="search_instructor"
                                id="search_instructor"
                                type="text"
                                className="search-instructor form-control"
                                placeholder="Filter: Name or NetID"
                                value={search.instructor}
                                onChange={this.handleInstructorSearchChange}
                            />
                            <hr />
                            <div className="user-buttons">
                                {this.renderUsersByRole(INSTRUCTOR)}
                            </div>
                        </CardBlock>
                    </Card>
                    <Card>
                        <CardHeader className="bg-primary">Students</CardHeader>
                        <CardBlock>
                            <input
                                name="search_student"
                                id="search_student"
                                type="text"
                                className="search-student form-control"
                                placeholder="Filter: Name, NetID, or Precept"
                                value={search.student}
                                onChange={this.handleStudentSearchChange}
                            />
                            <hr />
                            <div className="user-buttons">
                                {this.renderUsersByRole(STUDENT)}
                            </div>
                        </CardBlock>
                    </Card>
                </CardBlock>
            </div>
        :
            null
        ;
    }
}

EnrollmentPage.propTypes = {
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { auth, dropboxes, memberships, request, roles, roles_self, users } = state;

    return { auth, dropboxes, memberships, request, roles, roles_self, users };
}

export default connect(mapStateToProps)(EnrollmentPage);



/** WEBPACK FOOTER **
 ** ./src/containers/EnrollmentPage.js
 **/